import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Selecionar Cliente",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 600
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_selecionar_pessoa, {
            classCss: "ss-venda-dados-principais",
            style: {"width":"99%","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"},
            codigoSelecionado: _ctx.state.codigoPessoa,
            "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.codigoPessoa) = $event)),
            recursoOrigem: "VENDAS",
            empresas: [_ctx.props.empresa],
            preencherCodigoRelacao: true,
            codigoRelacao: _ctx.state.codigoCliente,
            "onUpdate:codigoRelacao": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.codigoCliente) = $event)),
            apresentarRelacoes: false,
            tipoRelacao: _ctx.ETipoRelacaoPessoa.Cliente,
            limparSelecao: false,
            onChange: _ctx.confirmar
          }, null, 8, ["codigoSelecionado", "empresas", "codigoRelacao", "tipoRelacao", "onChange"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}